// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"47f49eb8","139":"24d02409","319":"54708aa4","580":"aa2e5117","613":"26cc83a3","682":"887f8402","713":"01ea6e28","981":"c91938a7"}[chunkId] + ".chunk.js";
};